import {downgradeComponent} from '@angular/upgrade/static';
import {barnManagerModule} from '../../index.module';
import {ChipListComponent} from '@shared-ui/chip-list/chip-list.component';
import {ChipListDatesComponent} from "@shared-ui/chip-list-links/chip-list-dates.component";

barnManagerModule.directive('ng2SharedChipList', downgradeComponent({ component: ChipListComponent }));
barnManagerModule.directive('ng2SharedChipDatesList', downgradeComponent({ component: ChipListDatesComponent }));
